import { SubDomainContextsModel } from '../../../api/api';

export type ContextArtifactCounts = { entities: number; operations: number };

export function summarizeContextArtifacts(subDomains: SubDomainContextsModel[]) {
	const byContextId = new Map<string, ContextArtifactCounts>();
	let entities = 0;
	let operations = 0;

	for (const count of subDomains.flatMap((subDomain) => subDomain.contextArtifactCounts ?? [])) {
		entities += count.entityCount;
		operations += count.operationCount;
		byContextId.set(count.contextId, { entities: count.entityCount, operations: count.operationCount });
	}

	return { entities, operations, byContextId };
}
